<!--
 * @description: 维修--设备返回
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      :showConditionSearch="false"
      :showCondition="true"
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="RepairTransferReturn"
      :condition="conditionData2"
      editType="pop"
      :autoSearch="true"
      :showCancelButton="false"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
      :popToCustomer="true"
    >
      <template v-slot:tabelTitleLeft class="headerTitle">
        <div>设备返回</div>
      </template>
      <template v-slot:tabelTitleRight>
        <!-- <add-button @buttonClick="arrReturn">
					批量返回
				</add-button> -->
        <add-button @buttonClick="CommitsBtn"> 提交 </add-button>
      </template>

      <template v-slot:condition style="height: 200px">
        <text-field
          v-model:value="conditionData.order"
          labelText="货运单号:"
          :requird="true"
          :clearable="true"
          type="text"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.compid"
          labelText="货运公司:"
          :requird="true"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectDataComp"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.meth"
          labelText="运输方法:"
          :requird="true"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguNameProduct"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.date"
          type="date"
          :requird="true"
          labelText="寄送时间:"
          clearable
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.note"
          labelText="备注:"
          class="condition-container-input"
        >
        </text-field>
      </template>

      <template v-slot:goBackBtn="$opData">
        <div class="opration">
          <div class="style-aaa" @click="delSingleUser($opData.data)">返回</div>
          <!-- <del-button class="item"
						:useConfirm="true" comfirmMessage="确定返回吗？" 
						comfirmOkText="确定" comfirmCancelText="取消" 
						:icon="false"
						@buttonClick="delSingleUser($opData.data)">返回</del-button> -->
        </div>
      </template>
    </tabel-panel>
  </div>
</template>

<script>
import textField from "@/components/textField.vue";
import delButton from "@/components/delButton.vue";
import addButton from "@/components/addButton.vue";
import controlButton from "@/components/controlButton.vue";
import updateButton from "@/components/updateButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import { CommitsRepair, RepairTransferReturnCancel } from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";
import { ElMessageBox } from "element-plus";

export default {
  name: "RepairTransferReturn",
  components: {
    textField,
    addButton,
    delButton,
    tabelPanel,
    popDialog,
    updateButton,
    controlButton,
  },
  data() {
    return {
      selectDataMeth: [],
      selectData: [],
      inputValue: "明细",
      activeName: "second",
      loadShow: false,
      rowData: null,
      rowTemplate: [
        {
          columnType: "check",
          width: "80",
        },
        {
          headerLabel: "客户姓名",
          width: 80,
          dataIndex: "LinkMan",
        },
        {
          headerLabel: "客户名称",
          width: 180,
          sortable: true,
          dataIndex: "CompName",
        },
        {
          headerLabel: "客户电话",
          width: 100,
          sortable: true,
          dataIndex: "TelNo",
        },
        {
          headerLabel: "客户地址", //0
          width: 250,
          dataIndex: "Address",
        },
        {
          headerLabel: "型号",
          width: 80,
          sortable: true,
          dataIndex: "ModelNoName",
        },
        {
          headerLabel: "SN",
          width: 160,
          sortable: true,
          dataIndex: "SerialNoName",
          dataRender: (v, { $index, column, row }) => {
            return (
              '<span style="color:' +
              (row.Distinguish == 1
                ? "green"
                : row.Distinguish == 2
                ? "blue"
                : row.Distinguish == 3
                ? "red"
                : "") +
              '">' +
              v +
              ""
            );
          },
        },
        {
          headerLabel: "备注",
          width: 80,
          dataIndex: "IllDesc",
        },
        {
          headerLabel: "附件",
          width: 80,
          dataIndex: "AttachName",
        },
        {
          headerLabel: "维修人",
          width: 80,
          sortable: true,
          dataIndex: "RepairManName",
        },
        {
          headerLabel: "维修完成日期",
          width: 120,
          sortable: true,
          dataIndex: "ReciveDate",
        },
        {
          headerLabel: "维修状态",
          width: 100,
          sortable: true,
          dataIndex: "State",
        },
        {
          headerLabel: "返回",
          slot: "goBackBtn",
          width: "100",
        },
      ],
      conditionData2: {},
      conditionData: {
        order: "",
        compid: null,
        meth: null,
        date: "",
        note: "",
        list: [],
      },
    };
  },
  activated() {
    this.reloadData();
  },
  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    // 'ruleForm.notexpress': function(newQuestion, oldQuestion) {
    // 	this._formDisabled(newQuestion)
    // },
    // 'ruleForm.Ser': function(new1, old) {
    // 	this.companyValue(new1)
    // },
    $route(to, from) {
      console.log(1235);
      // this.$refs.tabel.reloadData()
    },
  },
  methods: {
    //货运公司
    async selectDataComp() {
      let source = await tableApi.TransComp();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    //运输方法
    async selectOuguNameProduct() {
      let source = await tableApi.TransMethod();
      if (source.code == 0) {
        let data = source.data.list.map(({ Id, Name }) => {
          return {
            label: Name,
            value: Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 重新加载表格数据
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    // 删除通过id
    delSingleUser({ row }) {
      let id = row.Id;
      ElMessageBox.confirm("确定返回吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          RepairTransferReturnCancel({ id }).then((data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.reloadData();
            } else {
              errMsg(data.message);
            }
          });
        })
        .catch(() => {});
    },
    //弹层事件
    popConfirmButtonClick({ slotData }) {
      console.log(slotData);
    },
    // 提交按钮 >> 批量提交且判断是否是同一客户的功能后台来判断。
    CommitsBtn() {
      let param = this.conditionData;
      if (param.order === null || param.order === "") {
        return errMsg("请填写货运单号");
      }
      if (param.compid === null || param.compid === 0) {
        return errMsg("请选择货运公司");
      }
      if (param.meth === null || param.meth === 0) {
        return errMsg("请选择运输方法");
      }
      if (param.date === null || param.date === "") {
        return errMsg("请选择寄送时间");
      }
      let sels = this.$refs.tabel.dataSource;
      // 收集列表ID
      let paramList = [];
      // 对比邮箱是否一致
      let CompNameList = [];
      sels.forEach((item) => {
        if (item.checked) {
          paramList.push({ id: item.Id });
          CompNameList.push({
            Email: item.Email,
            CompName: item.CompName,
          });
        }
      });
      if (paramList.length == 0) {
        return errMsg("请选择数据");
      }

      param.list = paramList;
      //增加提交修改用户邮箱功能
      // console.log('param:', param)
      // console.log('emailList:', CompNameList)
      // 是否为相同公司设备,邮箱
      let CompNameEvery = CompNameList.every(
        (i) => i.CompName == CompNameList[0].CompName
      );
      let EmailEvery = CompNameList.every(
        (i) => i.Email == CompNameList[0].Email
      );

      if (!CompNameEvery) {
        return errMsg("请选择相同公司设备进行返回");
      }
      if (!EmailEvery) {
        return errMsg("邮箱不一致不能批量提交");
      } else {
        let CompEmail = CompNameList.map((i) => i.Email);
        // console.log('CompEmail:', CompEmail)
        this.$prompt("是否修改邮箱", "客户邮箱地址", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern:
            /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: "邮箱格式不正确",
          inputPlaceholder: CompEmail[0],
          inputValue: CompEmail[0],
        })
          .then(({ value }) => {
            param.Email = value;
            CommitsRepair(param).then((data) => {
              if (data.code == 0) {
                successMsg(data.message);
                this.reloadData();
              } else {
                errMsg(data.message);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消提交",
            });
          });
      }
    },

    // arrReturn() {
    // 	let source = this.$refs.tabel.dataSource;
    // 	let flag = source.map(item => item.checked)
    // 	if (!flag.length) {
    // 		errMsg("请选择要返回的数据")
    // 	}

    // }
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: red;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }

  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }

    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }
}

.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
</style>
